import { Component } from '@angular/core';
import { FormField } from '../../class/form-field';

@Component({
  selector: 'app-custom-form-text-question',
  templateUrl: './custom-form-text-question.component.html',
  styleUrls: ['./custom-form-text-question.component.scss']
})
export class CustomFormTextQuestionComponent extends FormField { }
